<template>
  <a-row :gutter="16">
    <a-col :span="12">
      <div style="height:30px">企业电话</div>
      <a-input
        placeholder="请输入企业联系方式"
        :value="phone"
        @change="handleChange"
      />
    </a-col>
    <a-col :span="12">
      <div style="height:30px">邮箱</div>
      <a-input
        placeholder="请输入企业邮箱"
        :value="email"
        @change="handleChangeEmail"
      />
    </a-col>
  </a-row>
</template>
<script>
export default {
  props: ['value'],
  data() {
    const value = this.value || {};
    return {
      phone: value.phone,
      email: value.email,
    };
  },
  watch: {
    value(val = {}) {
      this.phone = val.phone;
      this.email = val.email;
    },
  },
  methods: {
    handleChange(e) {
      this.$emit(
        'change',
        Object.assign({}, this.$data, { phone: e.target.value }),
      );
    },
    handleChangeEmail(e) {
      this.$emit(
        'change',
        Object.assign({}, this.$data, { email: e.target.value }),
      );
    },
  },
};
</script>
